module.exports = __webpack_public_path__ + "static/media/vintage08.d46bcc4b.png";